import {PackageIcon} from '@primer/octicons-react'
import {Blankslate} from '@primer/react/experimental'

interface ArtifactsBlankSlateProps {
  heading: string
  description?: string
}

export const ArtifactsBlankSlate = ({heading, description}: ArtifactsBlankSlateProps) => (
  <Blankslate border spacious>
    <Blankslate.Visual>
      <PackageIcon size="medium" />
    </Blankslate.Visual>
    <Blankslate.Heading as="h2">{heading}</Blankslate.Heading>
    {description && <Blankslate.Description>{description}</Blankslate.Description>}
  </Blankslate>
)
